<template>
  <q-form
      v-if="isMounted"
      ref="form"
      class="c-vorder-desktop com"
      :style="{
        top: sideColumnTopOffsetCss,
        height: windowFreeHeightCss,
      }"
      v-sticky-state="{
        debugId: 'vorder',
        activeClass: 'stacked',
        top: sideColumnTopOffsetCss,
      }"
  >
    <ComponentDebugger :data="debug"/>

    <q-resize-observer @resize="onResizeContainer"/>

    <div class="c-vorder-desktop__inner bg-white">
      <div class="c-header q-py-sm" style="border-bottom: 1px solid #dddddd;">
        <div class="flex items-center justify-center q-px-md" style="position: relative;">


          <!-- Табы по центру -->
          <q-tabs
              v-model="tab"
              class="c-tabs"
              dense
              indicator-color="primary"
              narrow-indicator
              active-color="primary"
              active-bg-color="transparent"
          >
            <q-tab
                name="basket"
                class="q-px-md"
                label="Корзина"
            />
            <q-tab
                name="form"
                class="q-px-md"
                label="Заказ"
                v-if="!basketIsEmpty"
            />
          </q-tabs>

          <!-- Кнопка очистки корзины справа -->
          <q-btn
              v-if="tab === 'basket' && !basketIsEmpty"
              :icon="ICONS.trush"
              flat
              dense
              size="12px"
              color="red-8"
              class="c-clear-basket-btn"
              style="position: absolute; right: 16px;"
              @click="onClearBasket"
          >
            <q-tooltip class="s-font-2xs">
              Очистить корзину
            </q-tooltip>
          </q-btn>

        </div>
        <q-resize-observer @resize="onResizeHeader"/>
      </div>
      <div v-if="!scopeUserFetched" class="q-py-lg text-center">
        <q-spinner size="md" color="primary"/>
      </div>
      <template v-else>

        <div
            class="c-body scroll"
            :style="{maxHeight: freeSizeCss}"
        >

          <div class="q-pa-md text-center" v-if="false">
            <p class="text-red">Оформление заказа через сайт временно недоступно.</p>
            <p>Чтобы сделать заказ позвоните по номеру:.</p>
            <a href="tel:+73952506130" class="s-font-xl text-primary text-weight-bold">+7 (3952) 50-61-30</a>
          </div>

          <q-tab-panels
              v-model="tab"
              animated
              v-if="true"
          >
            <q-tab-panel name="basket" class="q-pt-none q-pb-md q-px-none">
              <Basket/>
            </q-tab-panel>
            <q-tab-panel name="form" class="q-pt-sm q-pb-md" v-if="!basketIsEmpty">
              <Form/>
            </q-tab-panel>
          </q-tab-panels>
        </div>

        <div class="c-footer" v-if=" (tab ==='basket' || !basketIsEmpty)">

          <template v-if="true">
            <div class="c-footer__section q-px-md q-py-md" v-if="tab ==='basket'">
              <BasketTransport/>
            </div>

            <template v-if="!basketIsEmpty">

              <div class="c-footer__section q-px-md q-py-md">

                <Summary/>

                <Alert
                    :message="{
                    messages: commonAlertMessages,
                    type: 'error'
                  }"
                    :outlined="true"
                    message-class="s-font-xs"
                    icon-size="13px"
                    v-if="commonAlertMessages.length"
                    class="c-errors q-mt-md"
                />

                <div class="q-mt-md">
                  <q-btn
                      v-if="tab === 'basket'"
                      color="primary"
                      label="Перейти к заказу"
                      class="full-width"
                      @click="changeTab('form')"
                      dense
                      unelevated
                  />
                  <q-btn
                      v-else
                      color="primary"
                      label="Оформить заказ"
                      class="full-width"
                      @click="submit"
                      dense
                      unelevated
                      :loading="submitRequest.loading"
                  />
                </div>

              </div>

            </template>

          </template>

          <q-resize-observer @resize="onResizeFooter"/>
        </div>
      </template>
    </div>

  </q-form>

</template>

<script setup lang="ts">

import Basket from "./Basket.vue";
import Form from "./Form.vue";
import BasketTransport from "./ui/BasketTransport.vue";
import Summary from "./ui/Summary.vue";

import {ICONS} from "@/assets/icons";
import ComponentDebugger from "@/components/Debug/ComponentDebugger.vue";
import Alert from "@/components/Ui/Alert/Alert.vue";
import {useLayout} from "@/core/composable/useLayout";
import {useScopeQuery} from "@/core/store/scopeQuery";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useLayoutStore} from "@/stores/layout";
import {useMounted} from "@vueuse/core";
import {storeToRefs} from "pinia";
import {QForm, useQuasar} from "quasar";
import {computed, provide, ref} from "vue";
import {VOrderComponentInject} from "./constants";
import {useVorderComponent} from "./hooks";
import {useUserStore} from "@/modules/user/store/user";
import {useVorderSubmit} from "@/modules/shop/store/vorder-submit";

const q = useQuasar()

const scopeQueryStore = useScopeQuery()
const layoutStore = useLayoutStore()
const vorderState = useVorderState()
const basketStore = useBasketStore()
const userStore = useUserStore()
const vorderSubmitStore = useVorderSubmit()

const layout = useLayout()

const form = ref<QForm>()
const isMounted = useMounted()

const vorderComponent = useVorderComponent(form)
const {submit, changeTab, debug, commonAlertMessages, showBasketAction} = vorderComponent

const {submitRequest} = vorderSubmitStore
const {sideColumnTopOffsetCss, sideColumnTopOffset} = storeToRefs(layoutStore)
const {onResizeContainer, onResizeHeader, onResizeFooter, freeSizeCss} = layout

const {scopeUserFetched} = storeToRefs(scopeQueryStore)
const {isAuthorized} = storeToRefs(userStore)

provide(VOrderComponentInject, vorderComponent)

const windowFreeHeightCss = computed(() => {
  return (q.screen.height - sideColumnTopOffset.value) + 'px'
})

const {basketOp} = basketStore

const {
  tab,
} = storeToRefs(vorderState)

const {
  basketIsEmpty,
} = storeToRefs(basketStore)

// Функция очистки корзины
const onClearBasket = () => {
  q.dialog({
    title: "Очистить корзину?",
    message: "Все товары будут удалены из корзины",
    cancel: "Отмена",
    ok: "Очистить",
  }).onOk(() => {
    basketOp({action: "clear"});
  });
};

</script>

<style scoped lang="scss">

.c-vorder-desktop {
  transition: all 0.3s ease-in-out;
  position: sticky;

  &:not(.stacked) {

  }

  .c-vorder-desktop__inner {
    box-shadow: 0 5px 15px -5px rgba(34, 60, 80, 0.2);
    border-radius: 8px;
    overflow: hidden;
  }
}

.c-body {
  transition: all 0.15s ease-in-out;
  //border: 1px solid#333333;
}

.c-header {
  //border-bottom: 1px solid #DDDDDD;
  //background-color: #eeeeee;
}

.c-footer {
  z-index: 100;
  //background-color: #eeeeee;
  //position: fixed;
}

.c-footer__section {
  border-top: 1px solid #dddddd;
}

.с-sections {
  background-color: rgba(28, 28, 28, 0.05);
  border-radius: 14px;
  padding: 2px 0 0 0;
  overflow: hidden;;

  :deep() {
    .c-section:not(:last-child) {
      border-bottom: 1px solid #DDDDDD;
    }
  }
}

.c-tabs {
  :deep(.q-focus-helper) {
    background-color: transparent !important;
  }
}

.c-clear-basket-btn {
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
}


</style>
